import { mimeTypeMap } from 'shared/domains/filesystem/utils/fileExtensions';
export const getMimeType = (file) => {
    if (file.type) {
        return file.type;
    }
    const ext = file.name.slice(file.name.lastIndexOf('.'));
    return mimeTypeMap.get(ext);
};
